module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_hospital--gray-68aca8ad7fd32118214bb4c0636458ae.svg";